import React, { useRef, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { format } from 'date-fns';

const SearchFilter = ({ filters, onChange, onApply }) => {
  const today = new Date(); // Get today's date
  const [dateRange, setDateRange] = useState([
    {
      startDate: filters.startDate || null,
      endDate: filters.endDate || null,
      key: 'selection',
    },
  ]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const dateInputRef = useRef(null);

  const handleDateChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setDateRange([ranges.selection]);
    onChange('startDate', startDate);
    onChange('endDate', endDate);
    setShowDatePicker(false); // Close the date picker after selection
  };

  const handleClear = () => {
    setDateRange([{ startDate: null, endDate: null, key: 'selection' }]);
    onChange('startDate', null);
    onChange('endDate', null);
    onChange('status', '');
  };

  return (
    <div className="bg-white p-6 rounded shadow-md relative">
      <div className="grid grid-cols-2 gap-4">
        {/* Date Input */}
        <div>
          <label className="block text-gray-700 mb-2">Date Range</label>
          <input
            type="text"
            readOnly
            className="w-full p-2 border cursor-pointer"
            value={
              dateRange[0].startDate && dateRange[0].endDate
                ? `${format(dateRange[0].startDate, 'yyyy-MM-dd')} to ${format(dateRange[0].endDate, 'yyyy-MM-dd')}`
                : ''
            }
            placeholder="Select date range"
            onClick={() => setShowDatePicker(true)}
            ref={dateInputRef}
          />
          {showDatePicker && (
            <div className="relative z-10 mt-2 bg-white shadow-lg rounded">
              <DateRangePicker
                ranges={dateRange}
                onChange={handleDateChange}
                className="border p-2"
                maxDate={today} // Disable future dates
              />
              <button
                className="mt-2 bg-gray-500 text-white px-4 py-1 rounded w-full"
                onClick={() => setShowDatePicker(false)}
              >
                Close
              </button>
            </div>
          )}
        </div>
        {/* Status Select Dropdown */}
        <div>
          <label className="block text-gray-700 mb-2">Status</label>
          <select
            className="w-full p-2 border"
            value={filters.status}
            onChange={(e) => onChange('status', e.target.value)}
          >
            <option value="">Select Status</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
          </select>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="mt-4 flex justify-between">
        <button className="bg-gray-400 text-white px-4 py-2 rounded" onClick={handleClear}>
          Clear
        </button>
        <button className="bg-purple-500 text-white px-4 py-2 rounded" onClick={onApply}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default SearchFilter;
